import React from 'react';
// @ts-ignore
import { createRoot } from 'react-dom/client';

import "./configs/i18n";

import "./assets/css/index.scss";
import "@wf/ui-kit/dist/es/index.css";
import App from "./components/App";

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(<App />);
